"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _globalStyle = require("./global-style");

var _lodash = _interopRequireDefault(require("lodash.merge"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defaultTheme = {
  breakpoint: {
    xs: 576,
    md: 768,
    lg: 992,
    xl: 1200
  },
  indent: {
    small: '0.25rem',
    medium: '0.5rem',
    regular: '1rem',
    large: '2rem'
  },
  palette: {
    lightest: '#fcfcfc',
    light: '#f2f2f2',
    neutral: '#d8d8d8',
    dark: '#727272',
    darkest: '#1a1a1a',
    'negative-light': '#e3871a',
    negative: '#db821a',
    'positive-light': '#97e31a',
    positive: '#8dd419',
    'primary-light': '#1e96ff',
    primary: '#1a81db',
    white: '#fcfcfc',
    black: '#1a1a1a'
  },
  font: {
    body: 'Source Sans Pro',
    article: 'Lora',
    code: 'Source Code Pro'
  },
  layer: {
    topmost: 1000,
    top: 800,
    middle: 500,
    bottom: 100
  },
  transition: '300ms',
  borderRadius: '0.125rem'
};

var ThemeProvider = function ThemeProvider(_ref) {
  var _ref$override = _ref.override,
      override = _ref$override === void 0 ? {} : _ref$override,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: (0, _lodash["default"])(defaultTheme, override)
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children, /*#__PURE__*/_react["default"].createElement(_globalStyle.GlobalStyle, {
    theme: (0, _lodash["default"])(defaultTheme, override)
  })));
};

exports.ThemeProvider = ThemeProvider;
ThemeProvider.propTypes = {
  children: _propTypes["default"].node.isRequired,
  override: _propTypes["default"].exact({
    breakpoint: _propTypes["default"].exact({
      xs: _propTypes["default"].number,
      md: _propTypes["default"].number,
      lg: _propTypes["default"].number,
      xl: _propTypes["default"].number
    }),
    indent: _propTypes["default"].exact({
      small: _propTypes["default"].string,
      medium: _propTypes["default"].string,
      regular: _propTypes["default"].string,
      large: _propTypes["default"].string
    }),
    palette: _propTypes["default"].exact(_objectSpread({}, ['primary', 'positive', 'negative', 'darkest', 'dark', 'neutral', 'light', 'primary-light', 'positive-light', 'negative-light', 'lightest', 'white', 'black'].reduce(function (obj, color) {
      return Object.assign(obj, _defineProperty({}, color, _propTypes["default"].string));
    }, {}))),
    font: _propTypes["default"].exact({
      body: _propTypes["default"].string,
      article: _propTypes["default"].string,
      code: _propTypes["default"].string
    }),
    layer: _propTypes["default"].exact({
      topmost: _propTypes["default"].number,
      top: _propTypes["default"].number,
      middle: _propTypes["default"].number,
      bottom: _propTypes["default"].number
    }),
    transition: _propTypes["default"].string,
    borderRadius: _propTypes["default"].string
  })
};
ThemeProvider.defaultProps = {
  override: defaultTheme
};